/**
 * 【KYMW1400】コマ情報登録VO
 *
 * @export RegistKomaModel
 * @class RegistKomaModel
 */
export class RegistKomaModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * ページ番号
   */
  public pageNum = Number(0);

  /**
   * セクションID
   */
  public sectionID = Number(0);

  /**
   * 始点X
   */
  public positionX = Number(0);

  /**
   * 始点Y
   */
  public positionY = Number(0);

  /**
   * 幅
   */
  public sizeW = Number(0);

  /**
   * 高さ
   */
  public sizeH = Number(0);
}
